import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  checkParallelism305j5epqg3ju0 as checkParallelism,
  namedOrThis1pi8a62t67wtr as namedOrThis,
} from './internal/LimitedDispatcher.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './internal/Symbol.mjs';
import { commonThreadLocal18t70xomalc6z as commonThreadLocal } from './internal/ThreadLocal.mjs';
import { createEventLoop3pvigh4qbw0m0 as createEventLoop } from './EventLoop.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function delta($this, unconfined) {
  return unconfined ? 4294967296n : 1n;
}
var EventLoopClass;
function EventLoop() {
  if (EventLoopClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.useCount_1 = 0n;
        this.shared_1 = false;
        this.unconfinedQueue_1 = null;
      }
      processUnconfinedEvent_mypjl6_k$() {
        var tmp0_elvis_lhs = this.unconfinedQueue_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var queue = tmp;
        var tmp1_elvis_lhs = queue.removeFirstOrNull_eges3a_k$();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var task = tmp_0;
        task.run_mvkpxh_k$();
        return true;
      }
      dispatchUnconfined_o79kaq_k$(task) {
        var tmp0_elvis_lhs = this.unconfinedQueue_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ArrayDeque().new_kotlin_collections_ArrayDeque_sf0swv_k$();
          this.unconfinedQueue_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var queue = tmp;
        queue.addLast_gaaijb_k$(task);
      }
      get_isUnconfinedLoopActive_g78ri6_k$() {
        return this.useCount_1 >= delta(this, true);
      }
      get_isUnconfinedQueueEmpty_mi405s_k$() {
        var tmp0_safe_receiver = this.unconfinedQueue_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isEmpty_y1axqb_k$();
        return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
      }
      incrementUseCount_jadqvy_k$(unconfined) {
        this.useCount_1 = add(this.useCount_1, delta(this, unconfined));
        if (!unconfined)
          this.shared_1 = true;
      }
      decrementUseCount_x8i8ca_k$(unconfined) {
        this.useCount_1 = subtract(this.useCount_1, delta(this, unconfined));
        if (this.useCount_1 > 0n)
          return Unit_instance;
        // Inline function 'kotlinx.coroutines.assert' call
        if (this.shared_1) {
          this.shutdown_cplwmy_k$();
        }
      }
      limitedParallelism_c4w1v3_k$(parallelism, name) {
        checkParallelism(parallelism);
        return namedOrThis(this, name);
      }
      shutdown_cplwmy_k$() {
      }
    }
    initMetadataForClass($, 'EventLoop');
    EventLoopClass = $;
  }
  return EventLoopClass;
}
var ThreadLocalEventLoopClass;
function ThreadLocalEventLoop() {
  if (ThreadLocalEventLoopClass === VOID) {
    class $ {
      constructor() {
        ThreadLocalEventLoop_instance = this;
        this.ref_1 = commonThreadLocal(new (Symbol())('ThreadLocalEventLoop'));
      }
      get_eventLoop_wo5hfs_k$() {
        var tmp0_elvis_lhs = this.ref_1.get_26vq_k$();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = createEventLoop();
          ThreadLocalEventLoop_getInstance().ref_1.set_tg4fwj_k$(this_0);
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForObject($, 'ThreadLocalEventLoop');
    ThreadLocalEventLoopClass = $;
  }
  return ThreadLocalEventLoopClass;
}
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance === VOID)
    new (ThreadLocalEventLoop())();
  return ThreadLocalEventLoop_instance;
}
//region block: exports
export {
  ThreadLocalEventLoop_getInstance as ThreadLocalEventLoop_getInstance1hcnqqlyaexyz,
  EventLoop as EventLoopljivmgnf56lj,
};
//endregion

//# sourceMappingURL=EventLoop.common.mjs.map
